import Lottie from 'lottie-react';
import styled from 'styled-components';
import loadingSpinnerData from 'assets/loading-spinner.json';

const SpinnerContainer = styled.div<{ $size?: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ $size }) => $size || 50}px;
  height: ${({ $size }) => $size || 50}px;
`;

const OverlayContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

interface LoadingSpinnerProps {
  size?: number;
  overlay?: boolean;
}

export function LoadingSpinner({ size = 50, overlay = false }: LoadingSpinnerProps) {
  const spinner = (
    <SpinnerContainer $size={size}>
      <Lottie
        animationData={loadingSpinnerData}
        loop={true}
        autoplay={true}
        style={{ width: size, height: size }}
      />
    </SpinnerContainer>
  );

  if (overlay) {
    return <OverlayContainer>{spinner}</OverlayContainer>;
  }

  return spinner;
}
